import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["step"];
let _ = t => t,
  _t;
import { createGlobalStyle } from 'styled-components';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIModal from 'UIComponents/dialog/UIModal';
import H3 from 'UIComponents/elements/headings/H3';
import OnboardingTourButtons from '../OnboardingTourButtons';
import * as tourHooks from '../../../js/hooks/tour';
import Confetti from '../Confetti';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// Hide the banner from modals and show it only after the user action on the modal CTA.
const HandholdingBannerGlobalStyle = createGlobalStyle(_t || (_t = _`
  .uiFullScreenBackground #onboarding-tours-banner-frame {
    filter: blur(5px);
    z-index: auto !important
  }
`));
const OnboardingTourModal = props => {
  const {
      step: {
        title,
        text,
        actionText,
        buttons,
        modal
      }
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const modalProps = modal !== undefined && typeof modal !== 'boolean' ? modal : {};
  const {
    showConfetti
  } = modalProps;
  const {
    useTourContext,
    useIsLastStep
  } = tourHooks;
  const {
    tour
  } = useTourContext();
  const isOnLastStep = useIsLastStep();
  const handleClose = () => {
    tour.finish();
  };
  return /*#__PURE__*/_jsxs(UIModal, Object.assign({}, rest, {
    className: "m-top-0",
    use: "conversational",
    width: 550,
    children: [showConfetti && /*#__PURE__*/_jsx(Confetti, {
      widthPercentage: 300
    }), /*#__PURE__*/_jsxs(UIDialogHeader, {
      className: "text-left",
      children: [/*#__PURE__*/_jsx(H3, {
        children: title
      }), isOnLastStep && /*#__PURE__*/_jsx(UIDialogCloseButton, {
        "data-test-id": "onboarding-tour-modal-close-button",
        onClick: handleClose
      })]
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      className: "p-top-6 text-left",
      children: [/*#__PURE__*/_jsx("div", {
        children: text
      }), actionText && /*#__PURE__*/_jsx("div", {
        className: "p-top-4",
        children: /*#__PURE__*/_jsx("strong", {
          children: actionText
        })
      })]
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      children: /*#__PURE__*/_jsx(OnboardingTourButtons, {
        buttons: buttons || []
      })
    }), /*#__PURE__*/_jsx(HandholdingBannerGlobalStyle, {})]
  }));
};
export default OnboardingTourModal;